import { KubernetesNodesRequestParams } from '../../../api/nm-types'
import { FilterBy, FilterTemplate } from '../../common/Filters/FilterView/FilterTemplate'

export enum ListK8sNodesFilterKey {
  name = 'name',
  search = 'search phrase',
}

export function mapK8sNodeFilterToUrlParam(filter: FilterBy): Partial<KubernetesNodesRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case ListK8sNodesFilterKey.name:
        return { name: filter.value }
      case ListK8sNodesFilterKey.search:
        return { filter: filter.value }
    }
  }
  return {}
}

export function mapUrlParamToK8sNodeFilter(
  key: keyof KubernetesNodesRequestParams,
  value: string,
): FilterBy | undefined {
  switch (key) {
    case 'name':
      return {
        key: ListK8sNodesFilterKey.name,
        operator: 'matches',
        value,
      }
    case 'filter':
      return {
        key: ListK8sNodesFilterKey.search,
        operator: 'matches',
        value,
      }
  }
  return undefined
}

export function makeListK8sNodesFilter(): FilterTemplate[] {
  const filterTemplates: FilterTemplate[] = [
    { key: ListK8sNodesFilterKey.search, operator: 'matches' },
    { key: ListK8sNodesFilterKey.name, operator: 'matches' },
  ]
  return filterTemplates.sort((a, b) => a.key.localeCompare(b.key))
}
